import gsap from "gsap";

export default class StickyButton {
  constructor(button) {
    let isMagnetic = false;
    const max = 0.55;
    const min = 0.3;
    let timeout = false;
    const filler = button.querySelector('.button__filler');

    button.addEventListener('mouseenter', () => {
      gsap.killTweensOf(filler);
      gsap.to(filler, {
        duration: 0.5,
        ease: 'power3.out',
        startAt: {y: '-75%'},
        y: '0%'
      })
    });
    button.addEventListener('mouseleave', () => {
      gsap.killTweensOf(filler);
      gsap.to(filler, {
        duration: 0.4,
        ease: 'power3.out',
        y: '75%'
      })
    });

    const grab = (dx, dy) => {
      if (timeout) {
        window.cancelAnimationFrame(timeout);
      }

      timeout = window.requestAnimationFrame(() => {
        gsap.to(button, {
          duration: 0.4,
          x: 0.25 * dx,
          y: 0.25 * dy,
          rotation: 0.02 * dx,
          ease: 'power2.out'
        });
      });
    };

    const reset = () => {
      if (timeout) {
        window.cancelAnimationFrame(timeout);
      }

      timeout = window.requestAnimationFrame(() => {
        gsap.to(button,  {
          duration: 0.85,
          delay: 0.15,
          x: 0,
          y: 0,
          scale: 1,
          rotation: 0,
          ease: 'expo.out'
        });
      });
    };

    this.stickyButtonHandler = (e) => {
      const mouse = {
        x: e.clientX + window.scrollX,
        y: e.clientY + window.scrollY
      };

      const maxDistance = isMagnetic ? max : min;
      const buttonMetas = button.getBoundingClientRect();
      const width = buttonMetas.width;
      const height = buttonMetas.height;
      const center = {
        x: buttonMetas.left + window.scrollX + width / 2,
        y: buttonMetas.top + window.scrollY + height / 2
      };
      const dx = mouse.x - center.x;
      const dy = mouse.y - center.y;
      let isTransformed = false;

      if (Math.abs(dx) < width * maxDistance && Math.abs(dy) < height * maxDistance) {
        isTransformed = true;
        if (!isMagnetic) {
          isMagnetic = true;
        }
        grab(dx, dy);
      }

      if (!isTransformed && isMagnetic) {
        reset();
        isMagnetic = false;
      }
    };

    window.wrapper.addEventListener('mousemove', this.stickyButtonHandler);
  }
}
